<template>
  <div id="login-warp" class="bg_img" :style="{height: viewHeight}">
    <div id="login">
      <transition :name="settings.visible ? 'slideleft' : 'slideright'">
        <div class="login">
          <div>
            <img class="logo" src="@/assets/qrcode_icon.png" alt="logo" @click="settings.useBarCode = !settings.useBarCode">
          </div>
          <div v-if="!settings.useBarCode">
            <!--表单登录-->
            <div class="logo-info">
              <p class="name">
                <span class="sub">孤独症测评系统</span>
              </p>
            </div>
            <!-- .logo-info -->
            <IForm ref="login" :model="login" :elem="loginElem" :rules="loginRule" :btn-loading="$store.state.app.loading"
                   :submit="false" split-model="24" @on-submit="toSubmit">
              <Button long type="primary" @click="handleLogin" :style="{'color':'#fff','background':((!login.username||!login.password)?'#2d8cf080':'#2d8cf0'),'border-color':((!login.username||!login.password)?'#2d8cf080':'#2d8cf0')}"
                      :disabled="(!login.username||!login.password)">登录</Button>
            </IForm>
          </div>
          <div v-else>
            <!--二维码登录-->
            <img src="@/assets/zyk_app.jpg" height="295" width="295"/>
            <p class="version">扫码使用小程序</p>
          </div>
        </div>
        <!-- IConfig -->
        <IConfig v-if="settings.visible" />
      </transition>
    </div>
    <!-- #login -->
    <IError />
    <!-- IError -->

  </div>
</template>
<script>
import config from "@/config";
import ax from "@/utils/axios";
import { _login } from "@/services/app";
import IConfig from "@/layouts/partials/Config";
import IError from "@/layouts/partials/Error";

export default {
  name: "Login",
  components: {
    IConfig,
    IError
  },
  data: () => ({
    viewHeight: "100vh",
    // 设置属性对象
    settings: {
      button: false,
      visible: false,
      useBarCode: false,
    },
    // 表单数据对象(登录)
    login: {
      username: "",
      password: "",
      platform: 3
    },
    // 表单元素数组(登录)
    loginElem: [
      {
        prop: "username",
        placeholder: "请输入账号",
        prefix: "md-contact"
      },
      {
        prop: "password",
        placeholder: "请输入密码",
        prefix: "md-lock",
        type: "password"
      },
      {
        prop: "platform",
        placeholder: "请选择登录平台",
        element: "select",
        prefix: "md-link",
        option: [{
          label: "孤独症",
          value: 3
        }]
      }
    ],
    // 表单验证规则(登录)
    loginRule: {
      username: [
        {
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }
      ],
      platform: [
        {
          required: true,
          message: "请选择登录平台",
          trigger: "blur",
          type:'number'
        }
      ]
    }
  }),
  mounted() {
    window.onresize = function() {
      this.viewHeight =window.screen.height+"px";
    };
    // 更新页面 title 元素内容
    this.$store.commit("TITLE", "Login");
  },
  methods: {
    // 用户登录
    handleLogin(){
      this.$refs["login"].handleSubmit('form');
    },
    toSubmit() {
      // 配置默认接口地址
      const baseURL = localStorage.getItem("newBaseAPI") || config.baseURL;
      if (!config.mock){
        ax.defaults.baseURL = baseURL;
      }
      this.$Loading.start();
      this.$store.commit("LOADING", true);
      // 模拟异步请求
      _login(this.login)
        .then(res => {
          this.$Loading.finish();
          this.$store.commit("LOADING", false);
          if (res.errcode === 1) {
            const userInfo = res.data;
            if (userInfo) {
              // 获取用户信息
              this.$store.commit("USER_INFO", userInfo);
              // 获取菜单列表
              this.$store.dispatch("handleMenu");
            }
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {
        this.$Loading.error();
        this.$store.commit("LOADING", false);
      });
    },
    setUserLoginForm(row){
      this.login = {
        username: row.username,
        password: row.password
      };
    }
  }
};
</script>
<style lang="postcss" scoped>
#login {
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  height: 450px;
  left: 70%;
  margin: -175px 0 0 -180px;
  padding-left: 36px;
  padding-right: 36px;
  position: fixed;
  top: 45%;
  width: 360px;
  /* 过渡动画 */
  & .slideleft-enter-active,
  & .slideright-enter-active {
    transform: translateX(0);
    transition: all 0.5s;
  }
  & .slideleft-enter,
  & .slideright-enter {
  }
  & .slideleft-leave-active,
  & .slideright-leave-active {
    transition: all 0.5s;
  }
  & .slideleft-leave,
  & .slideright-leave {
    transform: translateX(0);
  }
  & .slideleft-enter,
  & .slideright-leave-active {
    transform: translateX(300px);
  }
  & .slideleft-leave-active,
  & .slideright-enter {
    transform: translateX(-300px);
  }
  /* end */
  & .settings {
    bottom: 16px;
    position: absolute;
  }
  & .login {
    position: absolute;
    width: 288px;
    & .logo {
      height: 60px;
      position: relative;
      left: 92%;
    }
  }
  & .logo-info {
    height: 64px;
    margin-bottom: 22px;
    text-align: center;
    & .name {
      bottom: 14px;
      display: inline-block;
      font-size: 24px;
      //font-weight: 550;
      color:#000000;
      line-height: 28px;
      position: relative;
      text-align: center;
    }
    & .sub {
      font-size: 20px;
    }
  }
  & .version {
    color: #888;
    text-align: center;
  }
}
.bg_img{
  background-image: url("../assets/bg.png");
  background-repeat:no-repeat;
  /*height: 100vh;*/
  background-size: 100% 100%;
}

/deep/ .ivu-input {
  height: 38px;
}

/deep/ .ivu-select-single .ivu-select-selection {
  height: 38px;
}

/deep/ .ivu-input-prefix i{
  font-size: 20px;
}

/deep/ .ivu-input-prefix i, .ivu-input-suffix i {
  line-height: 38px;
}

/deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  line-height: 38px;
}

</style>
